import { cn } from "./utils";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import * as React from "react";

const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
            "peer data-[state=checked]:bg-slate-800 dark:data-[state=checked]:bg-slate-50 disabled:opacity-50 border border-slate-200 border-slate-800 dark:border-slate-50 dark:border-slate-500 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 dark:focus-visible:ring-slate-300 ring-offset-white focus-visible:ring-offset-2 dark:ring-offset-slate-900 dark:ring-offset-slate-950 w-4 h-4 data-[state=checked]:text-slate-50 dark:data-[state=checked]:text-slate-800 disabled:cursor-not-allowed shrink-0",
            className
        )}
        {...props}
    >
        <CheckboxPrimitive.Indicator className={cn("flex justify-center items-center text-current")}>
            <Check strokeWidth={3} size={20} />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
